import { Option, Zone } from 'types';

import { FormItem } from 'sections/EditForm';

const useFormData = (zones: Zone[]): FormItem[] => {
  const zonesIntoOptions = zones?.map(
    (zone): Option => ({
      value: zone.code,
      label: zone.code,
    })
  );

  return [
    {
      name: 'zone',
      label: 'zone',
      type: 'select',
      options: zonesIntoOptions,
    },
  ];
};

export { useFormData };
